// extracted by mini-css-extract-plugin
export default {"linksBoxTitle":"MatrixBox_linksBoxTitle__VPKvX","number":"MatrixBox_number__+GpIw"};